<template>
  <section>
    <div v-if="this.loading" class="d-flex flex-row justify-content-center loading_card">
      <!-- LOADER -->
      <div class="loading_card_spinner">
        <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3" color="var(--primary-color)" />

      </div>
      <!-- END LOADER -->

    </div>

    <div v-if="items.length == 0" class="login-wrapper">
      <div class="login-container">

        <!-- شاشة الدخول العادية -->
        <div id="login-form">
          <h1 class="empty_cart_title">{{ $t('Your cart is empty') }}</h1>

          <!-- <a class="forgot-password" href="#" id="forgot-link">Forgot your password?</a> -->
          <button @click="
            $router.push({
              name: 'home1',
              params: { storeName: $store.storeName, lang: $i18n.locale },
            })
            " type="submit" class="signin">{{ $t('Continu Shopping') }}</button>
          <p style="font-size: 30px; margin-top: 50px;">{{ $t('Have an account?') }}</p>
          <router-link :to="{
            name: 'home',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" class="create-account" href="#" style="text-decoration: none;margin-top: 0px;">
            <span v-if="!$localStorage.get($store.storeName)" style="text-decoration: underline;">
              <router-link :to="{
                name: 'login',
                params: { storeName: this.$store.storeName, lang: $i18n.locale },
              }" style="color:grey">{{ $t('logIn') }}</router-link></span> {{ $t('to check out faster') }}.
          </router-link>
        </div>



      </div>
    </div>
    <div v-else class="container">
      <div class="d-flex justify-content-between" style="align-items: center;">
        <h1>{{ $t('Your cart') }}</h1>
        <a @click="$router.push({
          name: 'home1',
          params: { storeName: $store.storeName, lang: $i18n.locale },
        })
          " style="text-decoration: underline; color: rgba(37, 37, 37, 0.75);;">
          {{ $t('Continue Shopping') }}</a>




      </div>

      <!-- Column headers -->
      <div v-if="this.items.length != 0" class="cart-header">
        <div class="title_cart">{{ $t('product') }}</div>
        <div class="title_cart">{{ $t('quantity') }}</div>
        <div class="title_cart">{{ $t('total') }}</div>
      </div>
      <!-- Item 1 -->
       <div class="text-center center-text">
      <i v-if="loading_items" class="fa fa-spinner fa-spin icon_loading" aria-hidden="true"></i>
      </div>

      <item_cart v-for="item in this.items" :key="item" :item-id="item"></item_cart>
      <hr>
      <div v-if="this.items.length != 0" class=" cart_end ">
        <div class="special-instructions">
          <label>{{ $t('Order special instructions') }}</label>
          <textarea></textarea>
        </div>
        <div class="total">
          <div style="    font-size: 19px;
          padding-bottom: 10px;">{{ $t('Estimated total') }}: {{
            (price * $store.state.rate).toFixed($store.state.digit_price) }}
            &nbsp;{{ $store.state.UnitPrice }}
          </div>
          <p>{{ $t('Taxes, discounts and shipping calculated at checkout.') }}
          </p>
          <button class="checkout-btn" v-if="this.$localStorage.get(this.$store.storeName) == null"
            @click="confirmOrder_guest()">
            <i v-if="loading_order" class="fa fa-spinner fa-spin icon_loading" aria-hidden="true"></i>
            {{ $t('Procced to Checkout') }}</button>
          <button class="checkout-btn" v-else @click="confirmOrder()">
            <i v-if="loading_order" class="fa fa-spinner fa-spin icon_loading" aria-hidden="true"></i>{{ $t('Procced to
            Checkout') }}</button>
          <button class="checkout-btn" style="background-color: transparent ;color:black;border:2px solid black;margin: 10px 0px 20px 0px;"
            @click="show = true">{{ $t('clear cart') }}</button>

        </div>

      </div>

    </div>
    <Transition name="modal">
      <div v-if="show" class="modal-mask ">
        <div class="modal-wrapper">
          <div class="modal-container float_card">
            <div class="modal-header">
              <slot name="header">
                <h6 style="width:100%;text-align:center">{{ $t('confirmdeleteAll') }}</h6>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button close" @click="deleteAllCookies()">
                  <i v-if="loading_order" class="fa fa-spinner fa-spin icon_loading" aria-hidden="true"></i>
                  {{ $t('confirm') }}</button>
                <button class="modal-default-button " @click="(show = false), $emit('close')">{{ $t('cancel')
                }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </section>
</template>

<script>
import item_cart from "../components/cart_item.vue";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
  components: { item_cart, HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner },
  data: function () {
    return {
      items: [],
      products: [],
      loading: false,
      show: false,
      price: 0,
      loading_order: false,
      loading_items:true,
    };
  },
  created() {
    this.$store.state.showHeader = true;
    this.$store.state.showFooter = true;
    let AllCookies = this.$cookies.keys();
    this.products = [];

    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        this.items.push(AllCookies[i]);
        this.products.push(this.$cookies.get(AllCookies[i]));

        if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
          this.price += this.$cookies.get(AllCookies[i]).offer_price;
        } else {
          this.price += this.$cookies.get(AllCookies[i]).total_price;
        }
        //console.log(this.items);
      }
    }
    console.log(this.items);
      setTimeout(() => {
              this.loading_items =false;
            }, 500);


    //console.log(this.items[0])
    /* this.$cookies.isKey(
          this.$store.storeName +
            product.product_id +
            product.final_option +
            product.option_check
        )*/

    if (this.$i18n.locale == 'ar') {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content = this.$store.state.description_ar;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
    }
    else {
      document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content = this.$store.state.description_en;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
    }
  },
  methods: {
    updateProducts() {
      console.log("hiiiiiiiiiiiiiii");
      this.products = [];
      this.price = 0;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
          this.products.push(this.$cookies.get(AllCookies[i]));

          if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
            this.price += this.$cookies.get(AllCookies[i]).offer_price;
          } else {
            this.price += this.$cookies.get(AllCookies[i]).total_price;
          }
          //console.log(this.items);
        }
      }
    },
    updatedata() {
      this.loading = true;
      this.items = [];
      this.products = [];
      this.price = 0;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
          this.items.push(AllCookies[i]);
          this.products.push(this.$cookies.get(AllCookies[i]));

          if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
            this.price += this.$cookies.get(AllCookies[i]).offer_price;
          } else {
            this.price += this.$cookies.get(AllCookies[i]).total_price;
          }
          //console.log(this.items);
        }
      }
      this.$store.state.langchange = false;
      setTimeout(() => {
        // this.updateall();
        this.loading = false;
      }, 0.1);
    },
    deleteAllCookies() {
      this.loading_order = true;
      this.loading = true;
      for (let i = 0; i < this.items.length; i++) {
        this.$cookies.remove(this.items[i]);
      }
      this.items = [];

      console.log("hiiiiiiii" + this.$cookies.keys());
      this.$store.state.cartCounter = 0;
      this.loading = false;
      this.show = false;
      this.loading_order = false;
    },
    confirmOrder() {
      this.loading_order = true;
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/check_all_item_card",
          {
            products: this.products,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.$router.push({
              name: "confirmOrder",
              params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
            });
          } else {
            alert(response.data.message);
            // this.couponMsg = response.data.message;
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/store";
          }
        });
    },
    confirmOrder_guest() {
      this.loading_order = true;
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/check_all_item_card",
          {
            products: this.products,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.$router.push({
              name: "guest_confirmOrder",
              params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
            });
          } else {
            alert(response.data.message);
            // this.couponMsg = response.data.message;
          }
          //this.addresses = response.data.data.addresses.addresses;
          // console.log(this.addresses);
        })
        .catch((error) => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/store";
          }
        });
    },
    login() {
      this.$router.push({
        name: "login",
        params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
      });
    }
  },
};
</script>